import {
  gridlinesSchema2,
  gridlines2
} from "./index-8agtsbw4.mjs";
export {
  gridlines2 as gridlines,
  gridlinesSchema2 as gridlinesSchema
};
